import {
  ApplicationConfig,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  inject,
  Provider,
  EnvironmentProviders,
} from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';
import { provideRouter, withInMemoryScrolling, withPreloading, withViewTransitions } from '@angular/router';
import { ViewTransitionService } from './services/view-transition.service';

import { routes } from './app.routes';
import { provideStore } from '@ngxs/store';
import {provideHttpClient, withFetch, withInterceptors} from '@angular/common/http';
import { authInterceptor } from './interceptors/auth.interceptor';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import '@angular/common/locales/global/ru';
import { AppState } from './state/app.state';
import { AppFacade } from './state/app.facade';
import {SelectivePreloadingStrategy} from './common/preloading/selective-preloading-strategy';
import { PushService } from './services/push.service';
import { PushHttpService } from './services/push.http.service';

const providers: Array<Provider | EnvironmentProviders> = [
  provideBrowserGlobalErrorListeners(),
  SelectivePreloadingStrategy,
  provideRouter(routes, withPreloading(SelectivePreloadingStrategy), withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
  {
    provide: LOCALE_ID,
    useValue: 'ru-RU'
  },
  provideHttpClient(
    withFetch(),
    withInterceptors([authInterceptor])
  ),
  provideAngularSvgIcon(),
  provideStore([AppState]),
  AppFacade,
  PushHttpService,
  PushService,
  provideServiceWorker('ngsw-worker.js', {
    // Временно отключён — вернуть: enabled: !isDevMode()
    enabled: false,
    registrationStrategy: 'registerWhenStable:30000'
  }),
]

export const appConfig: ApplicationConfig = {
  providers,
};
